<div [hidden]="!showLoader" class="loader-outer">
    <div id='loader'>

        <div class="circle-loader"></div>
        <img src="assets/img/logos/logo.png" class="logo" />
    </div>
</div>

<div class="innerpage-fullwithbanner dashboardarea clearfix">
    <div class="left">
        <h2 class="bighead">{{heading}}</h2>
        <ul class="bread-crumbs">
          <li *ngIf="this.Authentication.Principal() || this.Authentication.Seller() || this.Authentication.Principal1031()">
            <a (click)="onHomeBreadCrumbClick();">
              Home
              <span>|</span>
            </a>
          </li>
          <li *ngIf="!this.Authentication.Principal() && !this.Authentication.Seller() && !this.Authentication.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
          <li><a (click)="onExchangeBreadCrumbClick();" *ngIf="!IsPrincipal&&!IsFromParent">1031 Exchanges<span>|</span></a></li>
          <li *ngIf="currentMenu"><a [routerLink]="['/principal-dashboard']">My Portal<span>|</span></a></li>
          <li *ngIf="IsFromParent"><a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a></li>
          <li>1031 Trade</li>
        </ul>
    </div>
    <div class="right">

        <a class="linksdashboard brokericon" placement="left" tooltip="Associated Brokers" *ngIf="showAllExchange || this.Authentication.Admin()|| this.Authentication.SuperAdmin()" (click)="openBrokerModal(Brokers,'panlestyle');"><span class="icon-manager icon"></span></a>
        <a class="linksdashboard" placement="left" tooltip="Invite Principal" *ngIf="showAllExchange || IsBroker" (click)="openModal(Invite,'panlestyle');"><span class="icon-users icon"></span></a>
        <label *ngIf="IsPrincipal && exchangeCodes?.length > 0" class="select breadcumbarea-select bigselect">
            <div class="information" *ngIf="IsConnectedExchange" tooltip="Connected Exchange" placement="left"><span class="fa fa-info"></span></div>
            <select class="form-control" id="exchangeSelect" [(ngModel)]="selectedExchange" (change)="bindData();">
                <option *ngFor="let item of exchangeCodes" [(ngValue)]="item.Id">{{item.ExchangeCode}}</option>
            </select>
            <i></i>
        </label>
    </div>
    <div class="clearfix"></div>
</div>
<div class="clearfix"></div>
<div class="" *ngIf="!noData">
    <div class="">
        <div>
            <div class="">

                <div class="tabstyle2 dashboardtab min-heightcontainer1031 be-box" style="margin:auto;">
                    <tabset>
                        <tab heading="1031 Trade Dashboard" [active]="activeTabName === 'dashboard' || activeTabName === '' " (selectTab)="onTabSelect($event,tab.Dashboard)" id="dashboard">
                            <div class="dashboardstyles section-margin" *ngIf="showDashboard">
                              <div class="container min-heightcontainer">
                                <div class="cf res-timeline-wrap">
                                  <ul class="wizardstyle2 clearfix" *ngIf="exchangeDetails.ProjectedSaleDate">
                                    <li class="success">
                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>

                                      <p>Search Replacement Property</p>
                                    </li>
                                    <li [ngClass]="checkDatePassed(exchangeDetails.ProjectedSaleDate)">

                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>1031 Trade Start</p>
                                      <h6>{{exchangeDetails.ProjectedSaleDate|date:'d MMM y'}}</h6>

                                    </li>
                                    <li [ngClass]="checkDatePassed(identificationPeriod)">

                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>Identification Period</p>
                                      <h6>{{identificationPeriod|date:'d MMM y'}}</h6>

                                    </li>
                                    <li [ngClass]="checkDatePassed(finalCloseDate)">

                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>Final Close Date</p>
                                      <h6>{{finalCloseDate|date:'d MMM y'}}</h6>

                                    </li>
                                  </ul>
                                  <ul class="wizardstyle2 clearfix" *ngIf="!exchangeDetails.ProjectedSaleDate">
                                    <li class="success">
                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>Search Replacement Property</p>
                                    </li>
                                    <li class="inactive">
                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>1031 Trade Start</p>
                                    </li>
                                    <li class="inactive">
                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>Identification Period</p>
                                    </li>
                                    <li class="inactive">
                                      <div class="blueborder-circle">
                                        <span></span>
                                      </div>
                                      <p>Final Close Date</p>
                                    </li>
                                  </ul>
                                </div>

                                <div class="border-div">
                                  <ul class="listingone">
                                    <li>
                                      <h3>Total Exchange<span> / Closed</span></h3>
                                      <h4>${{exchangeDetails.Proceeds | number}}<span> / {{exchangeDetails.TotalExchangeClosed !== null ? '$'+ (exchangeDetails.TotalExchangeClosed|number) :'-'}}</span></h4>
                                    </li>
                                    <li>
                                      <h3>Equity</h3>
                                      <h4>{{exchangeDetails.Equity !== null ? '$'+ (exchangeDetails.Equity|number) :'-'}}</h4>
                                    </li>
                                    <li>
                                      <h3>Debt</h3>
                                      <h4>{{exchangeDetails.Debt !== null ? '$'+ (exchangeDetails.Debt|number) :'-'}}</h4>
                                    </li>
                                    <li>
                                      <h3>NOI Goal<span> / Closed</span></h3>
                                      <h4>{{exchangeDetails.NOIGoal !== null ? '$'+ (exchangeDetails.NOIGoal|number) :'-'}}<span> / {{exchangeDetails.NOIGoalClosed !== null ? '$'+ (exchangeDetails.NOIGoalClosed|number) :'-'}}</span></h4>
                                    </li>
                                    <li>
                                      <h3>ID Strategy</h3>
                                      <h4>{{exchangeDetails.IDStrategy ? exchangeDetails.IDStrategy :'-'}}</h4>
                                    </li>
                                  </ul>
                                </div>
                                <div class="bluebg-blocks margin-bottom-30">

                                  <ul class="clearfix">
                                    <li *ngFor="let Dashboard of DashboardOModel;let i=index" style="width:20%">
                                      <div class="whiteblock">
                                        <h2>{{Dashboard.Title}} <span [style.background-color]="Dashboard.Color"></span></h2>
                                        <h3>{{Dashboard.Price == null ? '-': '$'+ (Dashboard.Price |number) }}</h3>
                                        <h4>{{Dashboard.Count|number}} Properties</h4>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                <div class="text-right">
                                  <a (click)="onViewPipeline()" class="bluelinkunderline" style="margin-bottom: 5px">View pipeline</a>
                                </div>
                                <!--<div class="text-right">
                                  <a (click)="onGenerateExchange1031Report()" class="bluelinkunderline" style="margin-bottom: 5px">Generate 1031 Exchange Report</a>
                                </div>-->
                                <div *ngIf="showTimeChart"><app-time-remaining-info [exchangeSelected]="exchangeSelected" [IsConnectedExchange]="IsConnectedExchange" (changeActiveTab)="changeActiveTab($event);" (closeDate)="closeDate($event);"></app-time-remaining-info></div>

                              </div>
                            </div>
                        </tab>
                        <tab heading="Pipeline" *ngIf="showOffers" id="portfolio" [active]="activeTabName === 'portfolio' " (selectTab)="onTabSelect($event,tab.Portfolio)">
                            <div *ngIf="showTradePortfolio">
                                <app-1031-portfolio [exchangeSelected]="exchangeSelected" [breadCrumbInput]="breadCrumbPortfolio" [activeTab]="'portfolio'"></app-1031-portfolio>
                            </div>
                        </tab>
                        <tab heading="My Deals" *ngIf="showOffers" id="offers" [active]="activeTabName === 'offers'" (selectTab)="onTabSelect($event,tab.Deals)">
                            <div *ngIf="showDeals">
                              <my-property-view [PrincipalId]="PrincipalId" [exchangeSelected]="exchangeSelected" [exchangeGuid]="exchangeGuid" [breadCrumbInput]="breadCrumbInput" [activeTab]="'offers'"></my-property-view>
</div>
                        </tab>
                        <tab heading="Exchanges" *ngIf="showOffers && IsPrincipal " id="exchange" [active]="activeTabName === 'exchange'" (selectTab)="onTabSelect($event,tab.Exchange)">
                            <div *ngIf="showExchange">
                                <app-exchange-1031-list [PrincipalId]="PrincipalId" [breadCrumbInput]="breadCrumbInput" [currentTab]="'exchange'"></app-exchange-1031-list>
                            </div>
                        </tab>
                        <tab heading="Profile" *ngIf="showOffers && !Authentication.Principal1031()" id="profile" [active]="activeTabName === 'profile'" (selectTab)="onTabSelect($event,tab.Profile)">
                            <div *ngIf="showProfile">
                                <user-profiles [userGuidToView]="userGuidToView" [exchangeId]="selectedExchange" [exchangeOwner]="PrincipalId" [isFromExchange1031]="true"></user-profiles>
                            </div>
                        </tab>
                    </tabset>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="noData">
  <div class="tabstyle2 dashboardtab " style="background:#fff;">
    <ul class="switchingproperty">
      <li [class.active]="1==1">
        <a href="javascript:void(0);">
          1031 Trade Dashboard
        </a>
      </li>
      <li>
        <a href="javascript:void(0);">
          Pipeline
        </a>
      </li>
      <li>
        <a href="javascript:void(0);">
          Deals
        </a>
      </li>
      <li>
        <a href="javascript:void(0);">
          Exchanges
        </a>
      </li>
    </ul>
    <div class="successstep container min-heightcontainer margin-bottom-0">
      <img src="/assets/img/settings.png" class="centerimg" />
      <h4>Hi {{LoggedInUser.FirstName + ' '+ LoggedInUser.LastName}}, We are setting up your 1031 exchange.</h4>
      <h6>For assistance please contact your B+E Broker.</h6>
      <br />
      <div *ngIf="ExchangeInvitesList">

        <div class="initial-dashboard custom_no_dashboard" style="padding-top:0;">
          <ul class="connection-list brokerlist" style="max-width:none !important;">
            <li class="clearfix">
              <img [src]="ExchangeInvitesList.PhotoPath !=='' ? ExchangeInvitesList.PhotoPath  :'/../../../assets/img/default-profile-img.png'" />
              <div class="right">
                <h6>
                  {{ExchangeInvitesList.Name}}
                </h6>
                <p>
                  <i class="icon-phone icon"></i> {{ExchangeInvitesList.Phone|phone}}
                </p>
                <p>
                  <i class="icon-message icon"></i> {{ExchangeInvitesList.Email}}
                </p>
              </div>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="mobile_action_floated d-flex justify-content-between" *ngIf="activeTabName != 'profile'">
  <h3 class="exchange-hd">
    {{heading}}
  </h3>
  <a (click)="onGenerateExchange1031Report()" class="btn btn-success margin-left-10 btn-lg">Generate 1031 Report</a>
</div>
<div *ngIf="!noData">
  <app-financial-news [sellerId]="sellerId" *ngIf="this.Authentication.Seller() && activeTabName === 'dashboard'"></app-financial-news>
</div>

<ng-template #Invite class="pull-left">
    <app-exchange-1031-invite [selectedExchange]="exchangeSelected" [modalRefinvite]="modalRefInvite" (reload)="reload($event)" (close)="onInviteClose($event)"></app-exchange-1031-invite>
</ng-template>

<ng-template #Brokers class="pull-left">
    <div class="modal-header">
        <h4 class="modal-title pull-left">
            Associated Brokers
            <span class="badge">{{assignedBrokerCount|number}}</span>
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ul class="connection-list brokerlist" *ngIf="ExchangeInvitesList?.length !==0">
            <li class="clearfix" *ngFor="let invitee of ExchangeInvitesList">
                <img [src]="invitee.PhotoPath !=='' ? invitee.PhotoPath  :'/../../../assets/img/default-profile-img.png'" />
                <div class="right">
                    <h6>
                        {{invitee.Name}}
                    </h6>
                    <p>
                        <i class="icon-phone icon"></i> {{invitee.Phone|phone}}
                    </p>
                    <p>
                        <i class="icon-message icon"></i> {{invitee.Email}}
                    </p>
                </div>
            </li>
        </ul>
        <div class="nodata" *ngIf="ExchangeInvitesList?.length==0">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Brokers Assigned To This Exchange</p>
        </div>
    </div>

</ng-template>
<ng-template #templateMessageTab>
    <app-messages-view [SelexchangeId]="selectedExchange" [fromExchangeView]="true" [unreadMessageCountExchange]="unreadMessageCount" (unreadMessageCountDashboard)="setUnreadMessageCount($event)" [modalRef]="modalRef"></app-messages-view>
</ng-template>

